<template>
  <div
    class="refund-banner"
    v-bind="$attrs"
  >
    <div class="refund-banner__content">
      <h5 class="refund-banner__content__title">
        Вернём деньги,<br />
        если не примут
      </h5>
      <p class="refund-banner__content__description">Если работа не подойдёт, просто напишите нам — всё вернём</p>
    </div>
    <div class="refund-banner__image">
      <img
        class="refund-banner__image__ruble-circle"
        src="/images/refund-banner/ruble-circle.svg"
        alt="Refund Banner"
      />
      <div class="refund-banner__image__background-circle"></div>
      <div class="refund-banner__image__gradient-circle"></div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss">
.refund-banner {
  position: relative;
  border-radius: 32px;
  border: 4px solid $background-white;
  background: #ecffae;
  padding: 24px;
  user-select: none;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
    max-width: 216px;

    &__title {
      font-size: 22px;
      font-weight: 500;
      line-height: 28px;
      color: #364308;
      margin: 0;
      z-index: 3;
    }

    &__description {
      font-size: 13px;
      font-weight: 500;
      line-height: 17px;
      color: #364308;
      z-index: 3;
    }
  }

  &__image {
    &__background-circle {
      position: absolute;
      top: 45%;
      right: 14px;
      transform: translate(0, -50%);
      background: #dbff68;
      border-radius: 100%;
      width: 100px;
      height: 100px;
      z-index: 1;

      animation: fadeIn 300ms ease-in;
    }

    &__ruble-circle {
      position: absolute;
      top: 50%;
      right: 4px;
      transform: translate(0, -50%);
      z-index: 2;
      transform-origin: 54% 0%;

      animation: spin 1s cubic-bezier(0.07, 0.4, 0.1, 1);
    }

    &__gradient-circle {
      position: absolute;
      z-index: 0;
      right: -60px;
      bottom: -100px;
      width: 317px;
      height: 317px;
      border-radius: 317px;
      background: radial-gradient(50% 50% at 50% 50%, #fff 0%, rgba(236, 255, 174, 0) 100%);
      opacity: 0.5;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg) translate(0, -50%);
  }
  to {
    transform: rotate(-360deg) translate(0, -50%);
  }
}
</style>
